<template>
    <div class="water-list-warp">
        <div class="water-list-head">
            <div class="water-list-left">精彩推荐</div>
            <div class="water-list-more">
                <span>更多>></span>
                <wxopenbtn :type="type" :postid="postid" />
            </div>
        </div>
        <div class="water-list-content">
            <div ref="line1" class="water-list-content-l">
                <div class="water-list-item" v-for="(item, index) in water_list1" :key="index">
                    <van-image fit="fill" :src="item.url">
                        <template v-slot:loading>
                            <img class="default-pic" :src="logo_pic" alt="">
                        </template>
                    </van-image>
                    <div class="water-list-content-title">{{item.title}}</div>
                    <div class="water-list-content-user">
                        <van-image class="user-avatar" :src="item.users.avatar">
                            <template v-slot:error>
                                <img class="user-avatar" :src="default_pic" alt="">
                            </template>
                        </van-image>
                        <div class="user-nickname">{{item.users.nickname}}</div>
                        <img class="user-dianzan" :src="dian_zan_pic" alt="">
                        <span class="dianzan-count">{{bigNumToSmall(item.views)}}</span>
                    </div>
                    <wxopenbtn :type="item.type" :postid="item._id" />
                </div>
            </div>
            <div ref="line2" class="water-list-content-r">
                <div class="water-list-item" v-for="(item, index) in water_list2" :key="index">
                    <van-image fit="fill" :src="item.url">
                        <template v-slot:loading>
                            <img class="default-pic" :src="logo_pic" alt="">
                        </template>
                    </van-image>
                    <div class="water-list-content-title">{{item.title}}</div>
                    <div class="water-list-content-user">
                        <van-image class="user-avatar" :src="item.users.avatar">
                            <template v-slot:error>
                                <img class="user-avatar" :src="default_pic" alt="">
                            </template>
                        </van-image>
                        <div class="user-nickname">{{item.users.nickname}}</div>
                        <img class="user-dianzan" :src="dian_zan_pic" alt="">
                        <span class="dianzan-count">{{bigNumToSmall(item.views)}}</span>
                    </div>
                    <wxopenbtn :type="item.type" :postid="item._id" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import wxopenbtn from "./wxopenbtn.vue";
    export default {
        props: {
            postid: String,
            type: String
        },
        components: {
            wxopenbtn
        },
        data() {
            return {
                logo_pic: require("@/assets/lifecircle/logo.png"),
                default_pic: require("@/assets/lifecircle/default.png"),
                dian_zan_pic: require("@/assets/lifecircle/dian-zan-video.png"),
                water_list1: [],
                water_list2: []
            }
        },
        methods: {
            loadImagex(list) {
                this.doSort(0, list);
            },
            doSort(index, list) {
                if(index < list.length) {
                    if(this.$refs.line1.offsetHeight <= this.$refs.line2.offsetHeight) {
                        this.water_list1.push(list[index]);
                    } else {
                        this.water_list2.push(list[index]);
                    }
                    let that = this;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            that.doSort(index+1, list);
                        });
                    })
                }
            },
            bigNumToSmall(num){
                if(isNaN(Number(num))) return 0;
                const match = /(\d)+(\.+\d)?/;
                if (!num || num <=0) return 0;
                if (num < 10000) return num;
                const res = String(num/10000).match(match);
                if (res) {
                    return num >= 10000 ? `${res[0]}w` : num;
                }
                return num >= 10000 ? `${(num / 10000).toFixed(1)}w` : num;
            },
            getListFn(){
                this.$api.get("/life-moments/index/share-life/lists").then((res) => {
                    const list = res.data || [];
                    const new_list = [];
                    list.forEach(item => {
                        new_list.push({
                            _id: item._id,
                            url: item.type === "vide" ? item.img_video[0].thumbnail : item.img_video[0].completeUrl,
                            title: item.title,
                            users: item.users,
                            views: item.views,
                            type: item.type === "img" ? "life_circle_image_text" : "life_circle_video_detail"
                        })
                    });
                    setTimeout(() => {
                        this.loadImagex(new_list);   
                    });
                }).catch((err) => {
                    
                });
            },
            // wxExtinfo(post_id){
            //     console.log(encodeURIComponent(JSON.stringify({ type: "lifeCircle", post_id })));
            //     return encodeURIComponent(JSON.stringify({ type: "lifeCircle", post_id }))
            // }
        },
        mounted() {
            this.getListFn();
        },
    }
</script>

<style lang="less" scoped>
    .water-list-warp{
        .water-list-head{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .water-list-left{
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                line-height: 24px;
            }
            .water-list-more{
                position: relative;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                color: rgba(0,0,0,0.4);
            }
        }
        .water-list-content{
            .water-list-item{
                position: relative;
                margin-top: 20px;
                &/deep/.van-image__img{
                    width: 100%;
                    border-radius: 4px;
                    max-height: 250px;
                }
                &/deep/.van-image{
                    width: 100%;
                }
            }
            .water-list-content-l{
                box-sizing: border-box;
                float: left;
                width: 50%;
                padding-right: 4.5px;
            }
            .water-list-content-r{
                box-sizing: border-box;
                float: right;
                width: 50%;
                padding-left: 4.5px;
            }
            .water-list-content-title{
                max-height: 48px;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                line-height: 24px;
                overflow: hidden;
            }
            .water-list-content-user{
                display: flex;
                align-items: center;
                margin-top: 5px;
                .user-avatar{
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    overflow: hidden;
                }
                .user-dianzan{
                    width: 18px;
                    height: 18px;
                }
                .user-nickname{
                    flex: 1;
                    margin-left: 8px;
                    font-size: 12px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    color: #999999;
                    line-height: 17px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
                .dianzan-count{
                    margin-left: 4px;
                    font-size: 12px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    color: rgba(0,0,0,0.40);
                    line-height: 18px;
                }
            }
            .default-pic{
                width: 56px;
                height: 56px;
            }
        }
        
    }
</style>